// Speciální galerie — přestavba pro produkty s flag-specialni-galerie
$(document).ready(function () {
    if (!$(".type-detail").length) return;

    const $imageWrapper = $(".p-image-wrapper");
    const $pImage = $imageWrapper.find(".p-image");
    const $mainImage = $pImage.find(".p-main-image");
    const $thumbsContainer = $imageWrapper.find(".p-thumbnails-inner > div");
    const $allThumbs = $thumbsContainer.find(".p-thumbnail");

    // Šipky pro klasickou galerii — listování fotkami přes klik na sousední thumbnail
    function initClassicArrows() {
        if (!$pImage.length) return;

        $pImage.append(
            "<button class='sg-navi__btn sg-navi__btn--prev' aria-label='Předchozí'></button>" +
            "<button class='sg-navi__btn sg-navi__btn--next' aria-label='Další'></button>"
        );

        $pImage.on("click", ".sg-navi__btn", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $thumbs = $imageWrapper.find(".p-thumbnails-inner .p-thumbnail");
            if ($thumbs.length < 2) return;

            const direction = $(this).hasClass("sg-navi__btn--prev") ? -1 : 1;
            const current = $thumbs.index($thumbs.filter(".highlighted"));
            const next = (current + direction + $thumbs.length) % $thumbs.length;
            $thumbs.get(next).click();
        });
    }

    // Speciální galerie jen s flagem a minimálně 4 thumbnaily (1 hlavní + 3 lifestyle)
    if (!$imageWrapper.find(".flag-specialni-galerie").length || $allThumbs.length < 4) {
        initClassicArrows();
        return;
    }

    const isMobile = window.innerWidth < 500;

    // Extrakce lifestyle fotek (index 1, 2, 3) — pouze na desktopu
    const lifestyleData = [];
    const lifestyleCbox = [];

    if (!isMobile) {
        const toRemove = [];

        $allThumbs.each(function (i) {
            if (i >= 1 && i <= 3) {
                lifestyleData.push({
                    url: $(this).attr("href"),
                    alt: $(this).find("img").attr("alt") || ""
                });
                lifestyleCbox.push($(this).next(".cbox-gal"));
                toRemove.push($(this));
            }
        });

        // Odstranění lifestyle thumbnailů (cbox-gal zůstávají pro colorbox galerii)
        toRemove.forEach(function ($el) {
            $el.remove();
        });
    }

    // Zbylé thumbnaily → data pro swiper (na mobilu všechny, na desktopu bez lifestyle)
    const $remainingThumbs = $thumbsContainer.find(".p-thumbnail");
    const slides = [];

    $remainingThumbs.each(function () {
        slides.push({
            url: $(this).attr("href"),
            alt: $(this).find("img").attr("alt") || ""
        });
    });

    // Swiper — pouze pokud ≥ 2 fotky po extrakci lifestyle
    let sgSwiper = null;

    if (slides.length >= 1) {
        let slidesHtml = "";
        slides.forEach(function (slide, i) {
            if (i === 0) {
                slidesHtml += "<div class='swiper-slide' data-href='" + slide.url + "'>" +
                    "<a href='" + slide.url + "' class='sg-slide-link'>" +
                    "<img src='" + slide.url + "' alt='" + slide.alt + "' fetchpriority='high'>" +
                    "</a></div>";
            } else {
                slidesHtml += "<div class='swiper-slide' data-href='" + slide.url + "'>" +
                    "<a href='" + slide.url + "' class='sg-slide-link'>" +
                    "<img data-src='" + slide.url + "' alt='" + slide.alt + "'>" +
                    "</a></div>";
            }
        });

        const $swiperWrap = $("<div class='sg-swiper-wrap'>" +
            "<div class='swiper sg-swiper'><div class='swiper-wrapper'>" + slidesHtml + "</div></div>" +
            "<button class='sg-navi__btn sg-navi__btn--prev' aria-label='Předchozí'></button>" +
            "<button class='sg-navi__btn sg-navi__btn--next' aria-label='Další'></button>" +
        "</div>");

        $swiperWrap.insertBefore($pImage);
        $pImage.find(".flags").appendTo($swiperWrap);
        $pImage.hide();

        // Šipky bez podmínky — viditelné i při jedné fotce
        sgSwiper = new Swiper(".sg-swiper", {
            loop: slides.length > 1,
            navigation: {
                nextEl: ".sg-navi__btn--next",
                prevEl: ".sg-navi__btn--prev",
            },
        });

        // Lazy loading — při slideChange načíst aktivní + sousední slidy
        function loadNearbySlides() {
            $(".sg-swiper .swiper-slide-active, .sg-swiper .swiper-slide-next, .sg-swiper .swiper-slide-prev")
                .find("img[data-src]").each(function () {
                    $(this).attr("src", $(this).attr("data-src")).removeAttr("data-src");
                });
        }
        sgSwiper.on("slideChange", loadNearbySlides);
        loadNearbySlides();

        // Zvýraznění thumbnailu odpovídajícího aktivnímu slidu
        function highlightActiveThumb() {
            const url = slides[sgSwiper.realIndex].url;
            const $thumbs = $imageWrapper.find(".p-thumbnails-inner .p-thumbnail");
            $thumbs.removeClass("highlighted");
            $thumbs.filter("[href='" + url + "']").addClass("highlighted");
        }
        sgSwiper.on("slideChange", highlightActiveThumb);
        highlightActiveThumb();

        // Klik na thumbnail — přepnout slide ve swiperu
        $imageWrapper.on("click", ".p-thumbnail", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const href = $(this).attr("href");
            for (let i = 0; i < slides.length; i++) {
                if (slides[i].url === href) {
                    sgSwiper.slideToLoop(i, 300);
                    break;
                }
            }
        });

        // Colorbox — klik na swiper slide otevře odpovídající cbox-gal element
        $imageWrapper.on("click", ".sg-slide-link", function (e) {
            e.preventDefault();
            const href = $(this).attr("href");
            const $cbox = $thumbsContainer.find(".cbox-gal").filter(function () {
                return $(this).attr("href") === href;
            });
            if ($cbox.length) {
                $cbox.first().click();
            } else {
                $.colorbox({ href: href, photo: true, maxWidth: "95%", maxHeight: "95%" });
            }
        });

        // Přepnutí varianty — monkey-patch shoptet.products.replaceImage
        if (typeof shoptet !== "undefined" && shoptet.products && shoptet.products.replaceImage) {
            const originalReplaceImage = shoptet.products.replaceImage;
            shoptet.products.replaceImage = function () {
                const result = originalReplaceImage.apply(this, arguments);
                // Po výměně obrázku najít odpovídající slide
                const newSrc = $mainImage.find("img").attr("src");
                if (newSrc) {
                    const baseSrc = newSrc.split("?")[0];
                    for (let i = 0; i < slides.length; i++) {
                        if (slides[i].url.split("?")[0] === baseSrc) {
                            sgSwiper.slideToLoop(i, 300);
                            break;
                        }
                    }
                }
                return result;
            };
        }
    }

    // Lifestyle grid — 1 velká vlevo + 2 menší vpravo
    if (lifestyleData.length === 3) {
        const $lifestyle = $("<div class='sg-lifestyle'>" +
            "<a href='" + lifestyleData[0].url + "' class='sg-lifestyle__link'>" +
                "<img src='" + lifestyleData[0].url + "' alt='" + lifestyleData[0].alt + "' loading='lazy'>" +
            "</a>" +
            "<a href='" + lifestyleData[1].url + "' class='sg-lifestyle__link'>" +
                "<img src='" + lifestyleData[1].url + "' alt='" + lifestyleData[1].alt + "' loading='lazy'>" +
            "</a>" +
            "<a href='" + lifestyleData[2].url + "' class='sg-lifestyle__link sg-lifestyle__big'>" +
                "<img src='" + lifestyleData[2].url + "' alt='" + lifestyleData[2].alt + "' loading='lazy'>" +
            "</a>" +
        "</div>");

        $lifestyle.appendTo($imageWrapper);

        // Colorbox — klik na lifestyle fotku
        $lifestyle.on("click", ".sg-lifestyle__link", function (e) {
            e.preventDefault();
            const href = $(this).attr("href");
            for (let i = 0; i < lifestyleData.length; i++) {
                if (lifestyleData[i].url === href && lifestyleCbox[i]) {
                    lifestyleCbox[i].click();
                    break;
                }
            }
        });
    }

    $imageWrapper.addClass("sg-active");

    // Need help box — na mobilu před social buttons, na desktopu za lifestyle grid
    if (typeof window.buildNeedHelpBlock === "function") {
        const $needHelp = $(window.buildNeedHelpBlock());
        if (window.innerWidth < 768) {
            $needHelp.insertBefore(".social-buttons-wrapper");
        } else {
            $needHelp.appendTo($imageWrapper);
        }
    }

});
